// extracted by mini-css-extract-plugin
module.exports = {"toast-message_allignment":"error-toast_toast-message_allignment__d9BiJ"};